import type { Stat } from "./model";

const TOP: Record<string, string> = { "text-ink": "var(--ink)", "text-acc": "var(--acc)", "text-err": "var(--err)", "text-ok": "var(--ok)" };

/** Карточки статистики (M4): число mono 24, подпись, пояснение; верхняя кромка в цвет числа. */
export function Stats({ items }: { items: Stat[] }) {
  return (
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-3" data-testid="stats">
      {items.map((s) => (
        <div key={s.testId} className="rounded-md border border-bd bg-card px-4 py-3.5" style={{ borderTop: `2px solid ${TOP[s.tone] ?? "var(--bd)"}` }} data-testid={s.testId}>
          <div className={`font-mono text-[24px] font-bold leading-none ${s.tone}`}>{s.n}</div>
          <div className="mt-2 font-mono text-[12px] text-ink2">{s.label}</div>
          <div className="mt-0.5 text-[11.5px] text-mut">{s.note}</div>
        </div>
      ))}
    </div>
  );
}
